import React, { useState, useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import DraggableArea from './DragAndDrop/DraggableArea'
import FieldsForm from './FieldsForm'
import styles from './IdCardForm.module.scss'
import Field from "../../models/Field";
import Column from "../../models/Column";

export default function IdCardForm({ template, imageUrl, packageId }) {
  const [fields, setFields] = useState([])

  const BASE_OPTIONS = {
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: 0,
  };

  const client = new QueryClient({
    defaultOptions: {
      queries: { ...BASE_OPTIONS },
    },
  });

  useEffect(() => {
    Field
      .includes(['column', 'font', 'background'])
      .where({ templateId: template.id })
      .all()
      .then((res) => {
        const fieldsData = res.data.reduce((acc, field) => {
          return (
            {...acc,
              [field.id]: { label: field.column.name, id: field.id, left: field.x,
                top: field.y, width: field.width, height: field.height, object: field,
                color: field.color, spacing: field.spacing, fontId: field.fontId, backgroundId: field.backgroundId,
                text: field.text,
                textSize: field.textSize,
                columnType: field.column.columnType,
                fontName: field.font && field.font.name,
                wrap: field.wrap,
                sampleText: field.sampleText,
                png: field.png,
                customized: field.customized,
                personalizationBoxUrl: field.personalizationBoxUrl,
                background: field.background,
                align: field.align }})
        }, {})

        setFields(fieldsData)
      })
  }, [JSON.stringify(Object.keys(fields))])

  return (
    <QueryClientProvider client={client}>
      <div className={styles.container}>
        <DndProvider backend={HTML5Backend}>
          <DraggableArea fields={fields} setFields={setFields} imageUrl={imageUrl} template={template} />
        </DndProvider>
        <FieldsForm fields={fields} setFields={setFields} template={template} packageId={packageId} />
      </div>
    </QueryClientProvider>
  )
}
